<template>
  <UINavbarContainer
    placement="fixed-top"
    variant="primary"
    style="width: 100vw"
  >
    <NavbarMenuPrimary />

    <!-- Teleport destination for CTA button -->
    <div :id="navbarCtaId"></div>
  </UINavbarContainer>
</template>

<script lang="ts">
export const navbarCtaId = "navbar-cta";
</script>

<script setup lang="ts">
import UINavbarContainer from "@/components/UI/navbar/UINavbarContainer.vue";
import NavbarMenuPrimary from "./NavbarMenuPrimary.vue";
</script>
